
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Maria A., 90 ans, décédée le 15 avril 2020</b>
    <br />
    <br />
    <i>Son fils raconte:</i>
    <br />
    <p>
  «Je ne peux que remercier celles et ceux qui veulent rendre hommage aux
  personnes décédées des suites du Covid-19. Ce sont eux qui ont souffert en
  premier. Ce sont les premières victimes de cette terrible pandémie. Maman nous
  a quittés subitement. Elle n’avait pas de problème de santé et était en pleine
  forme avant d’être testée positive dans son foyer pour personnes âgées. Elle a
  immédiatement été transférée dans un autre établissement qui permettait un
  meilleur isolement, un meilleur traitement. Malgré cela, elle est décédée.
  Tout s’est passé très rapidement. Ce départ a été précipité, inattendu. Pour
  ceux qui restent, la douleur est immense. Il est très difficile, encore
  aujourd’hui, de faire ce deuil à cause des restrictions liées au coronavirus.
  Il y a d’abord eu l’interdiction de visite dans les EMS. Dès mi-mars, je ne
  pouvais plus la voir. Nous n’avions plus que des contacts téléphoniques. Puis
  le nombre de personnes durant les obsèques a été limité. Le contexte a rendu
  tout compliqué. J’ai ressenti beaucoup de souffrance. J’en ressens toujours,
  d’ailleurs. Fallait-il rendre public, sur l’avis mortuaire, la raison du
  décès? Certains ne l’ont pas fait par pudeur. Je comprends. Moi et ma famille
  avons mentionné le Covid-19 sur l’annonce de maman. C’est une manière de lui
  rendre hommage, à elle et à toutes les victimes du coronavirus. Cette mention
  est aussi là pour l’Histoire.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;